import axios from 'axios';
import interceptor from '@/utils/ad-api-interceptor';

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_HAMMER_API,
  // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});
interceptor.configAxios(service);
export default service;